/** @badge Native — TG Spinner (re-export from feedback/)
 *  @when   индикатор ожидания внутри кнопки/строки, где цвет и толщина не важны
 *  @not    пустое/загрузочное состояние экрана — это Skeleton по форме контента (ст.4)
 *  @breaks props `color`/`thickness` объявлены в feedback/Spinner, но нигде не читаются
 */
export { default as Spinner } from "../feedback/Spinner";
